import { Component } from '@angular/core'

@Component({
   selector: 'app-topics',
   standalone: true,
   imports: [],
   templateUrl: './topics.component.html',
   styles: ''
})
export class TopicsComponent {

}
